import React, { useEffect, useState } from 'react';
import { pagamentosApi } from '../api/api';

interface Props {
  onIrParaPagamento: () => void;
}

type Dados = {
  ativo: boolean;
  expiracao: string | null;
  modoTeste: boolean;
  diasRestantes: number | null;
  plano: { id: number; nome: string; valor: number; maxConexoes: number; maxDisparos: number; maxSessoesAtivas: number; especificacoes: string[] } | null;
};

export default function MinhaAssinaturaPage({ onIrParaPagamento }: Props) {
  const [dados, setDados] = useState<Dados | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    pagamentosApi.verificarAssinatura()
      .then(r => setDados(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="max-w-5xl mx-auto w-full">
        <div className="flex items-center justify-center h-64 text-sm text-ink-secondary">Carregando...</div>
      </div>
    );
  }

  const isAtivo = !!dados?.ativo;
  const isTeste = !!dados?.modoTeste;
  const diasRestantes = dados?.diasRestantes ?? 0;
  const especificacoes = dados?.plano?.especificacoes || [];

  const cta = !isAtivo ? 'Assinar agora' : isTeste ? 'Fazer upgrade' : 'Renovar plano';

  return (
    <div className="max-w-5xl mx-auto w-full space-y-5">

      <div>
        <h1 className="text-xl font-semibold text-ink-primary tracking-tight">Minha Assinatura</h1>
      </div>

      {/* Card largo: plano à esquerda + CTA à direita */}
      <div className="bg-white rounded-card border border-line p-6 flex items-center justify-between flex-wrap gap-5">
        <div className="min-w-0">
          <p className="text-base font-normal text-ink-secondary">Plano atual</p>
          <h2 className="text-2xl font-semibold text-ink-primary tracking-tight mt-1">
            {dados?.plano?.nome || (isTeste ? 'Teste gratuito' : 'Sem plano')}
          </h2>
          {isAtivo && (
            <p className="text-sm text-ink-secondary mt-1">
              {isTeste ? 'Aproveite o período de teste · ' : ''}
              <span className="font-semibold text-ink-primary">{diasRestantes}</span> {diasRestantes === 1 ? 'dia restante' : 'dias restantes'}
            </p>
          )}
        </div>

        <button
          onClick={onIrParaPagamento}
          className="text-sm font-semibold rounded-btn px-7 h-12 transition-opacity hover:opacity-80"
          style={{ background: '#22C55E', color: '#FFFFFF' }}
        >
          {cta}
        </button>
      </div>

      {/* Benefícios */}
      {especificacoes.length > 0 && (
        <div className="bg-white rounded-card border border-line p-6">
          <p className="text-base font-semibold text-ink-primary mb-4">Benefícios do seu plano</p>
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3.5">
            {especificacoes.map((esp, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-ink-primary">
                <span
                  className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mt-0.5"
                  style={{ background: '#3B82F6' }}
                >
                  <svg className="w-3 h-3" fill="none" stroke="#FFFFFF" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span className="leading-snug">{esp}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
